import angular from 'angular';
import { RegistrationGroup } from '../model/registrationGroup';
import moment from 'moment';
angular
  .module('cxRegistrations')
  .controller('RegEditGroupDialogCtrl', [
    '$element',
    'dataCache',
    'resourceFactorySvc',
    'registrationService',
    'flySvc',
    'close',
    'registration',
    'appUrls',
    '$http',
    '$filter',
    'checkSecurity',
    regEditGroupDialogCtrl,
  ]);

function regEditGroupDialogCtrl(
  $element,
  dataCache,
  resourceFactorySvc,
  registrationService,
  flySvc,
  close,
  registration,
  appUrls,
  $http,
  $filter,
  checkSecurity,
) {
  var vm = this;

  vm.showValidation = false;
  vm.registration = registration || new RegistrationGroup();
  vm.date =
    vm.registration.date ||
    moment
      .utc()
      .startOf('day')
      .toDate();
  var registrationResource = resourceFactorySvc.get('registration');

  var retrieveInteraction = function() {
    if (!vm.registration || !vm.registration.group || !checkSecurity('InteractionsOwn:r')) return;
    $http.get(appUrls.interactions + '/api/interactions/object/1/' + vm.registration.group).then(
      function({ data }) {
        if (data && data.length) {
          const interaction = data[0];
          vm.registration.interactionType = interaction.interactionType;
          vm.registration.interactionDescription = interaction.description;
          vm.registration.interactionId = interaction.id;
          vm.registration.interactionTitle = interaction.title;

          vm.registration.originalInteractionDescription = interaction.description;
          vm.registration.originalInteractionType = interaction.interactionType;
          vm.registration.originalInteractionTitle = interaction.title;
          vm.registration.originalInteraction = interaction;
        }
      },
      function(error) {
        console.error(error);
      },
    );
  };
  retrieveInteraction();

  vm.dateChanged = function(date) {
    if (vm.registration.group) return;

    registrationService.getNextRegistrationTime(date).then(function(data) {
      vm.registration.work.initTime(data.Hour, data.Minute, vm.registration.work.durationMinutes);
    });
  };

  vm.save = function() {
    if (vm.registration.group) {
      return registrationResource
        .update([vm.registration.work, vm.registration.travel, vm.registration.cost])
        .$promise.then(
          function(result) {
            var newReg = registrationService.createGroup(result, vm.date);
            newReg.translate($filter);
            return newReg;
          },
          function(error) {
            flySvc.error(error.data.code, error.data.parameters);
          },
        );
    } else {
      return registrationResource
        .save([vm.registration.work, vm.registration.travel, vm.registration.cost])
        .$promise.then(
          function(result) {
            var newReg = registrationService.createGroup(result, vm.date);
            newReg.translate($filter);
            return newReg;
          },
          function(error) {
            flySvc.error(error.data.code, error.data.parameters);
          },
        );
    }
  };
  vm.close = function(result) {
    $element.modal('hide');
    close(result, 500);
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
